import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ current, total, timeRemaining, timeLimit }) => {
  const progress = (current / total) * 100;
  const timeProgress = timeLimit ? ((timeLimit * 60 - timeRemaining) / (timeLimit * 60)) * 100 : 0;
  
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getTimeColor = () => {
    if (timeRemaining <= 300) return '#dc3545'; // Red for last 5 minutes
    if (timeRemaining <= 600) return '#fd7e14'; // Orange for last 10 minutes
    return '#28a745'; // Green otherwise
  };

  return (
    <div className="progress-container">
      <div className="progress-info">
        <span className="progress-text">
          Question {current} of {total}
        </span>
        {timeRemaining > 0 && (
          <span className="time-remaining" style={{ color: getTimeColor() }}>
            Time: {formatTime(timeRemaining)}
          </span>
        )}
      </div>
      
      <div className="progress-bars">
        <div className="progress-bar">
          <div className="progress-label">Progress</div>
          <div className="progress-track">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="progress-percentage">{Math.round(progress)}%</span>
        </div>
        
        {timeLimit && (
          <div className="progress-bar">
            <div className="progress-label">Time</div>
            <div className="progress-track">
              <div 
                className="progress-fill time-fill" 
                style={{ 
                  width: `${timeProgress}%`,
                  backgroundColor: getTimeColor()
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;